import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
type Variant = 'gold' | 'navy' | 'outline' | 'outlineLight';
type Size = 'sm' | 'md' | 'lg';
type ButtonProps = {
  children: React.ReactNode;
  variant?: Variant;
  size?: Size;
  to?: string;
  type?: 'button' | 'submit';
  onClick?: () => void;
  arrow?: boolean;
  disabled?: boolean;
  className?: string;
  ariaLabel?: string;
};
const variants: Record<Variant, string> = {
  gold: 'bg-gold text-midnight hover:bg-gold-300',
  navy: 'bg-midnight text-white hover:bg-midnight-700',
  outline: 'border border-midnight/25 text-midnight hover:border-midnight hover:bg-midnight hover:text-white',
  outlineLight: 'border border-white/30 text-white hover:border-gold-300 hover:text-gold-300'
};
const sizes: Record<Size, string> = {
  sm: 'h-9 px-4 text-sm',
  md: 'h-11 px-6 text-sm',
  lg: 'h-12 px-7 text-[15px]'
};
export function Button({
  children,
  variant = 'gold',
  size = 'md',
  to,
  type = 'button',
  onClick,
  arrow,
  disabled,
  className = '',
  ariaLabel
}: ButtonProps) {
  const classes = `group inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md font-medium transition-[background-color,color,border-color,transform] duration-150 ease-premium active:scale-[0.98] disabled:cursor-not-allowed disabled:opacity-60 ${variants[variant]} ${sizes[size]} ${className}`;
  const content = <>
      {children}
      {arrow && <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-premium group-hover:translate-x-0.5" aria-hidden="true" data-id="element-487" data-mp="12lscvc8o8bp0" />}
    </>;
  if (to) {
    return <Link to={to} className={classes} aria-label={ariaLabel} data-id="element-488" data-mp="1cc3g0wkj6guu">
        {content}
      </Link>;
  }
  return <button type={type} onClick={onClick} disabled={disabled} className={classes} aria-label={ariaLabel} data-id="element-489" data-mp="17etqlgx56570">
      {content}
    </button>;
}